import Component from './upload.vue';
export default Component;
